module.exports = __webpack_public_path__ + "static/media/02300011-LrS0wSgs.6dab9f15.JPG";